var React = require('react');

function RejectedReminder (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9ZM10.4142 9L13.2426 6.17157L11.8284 4.75736L9 7.58579L6.17157 4.75736L4.75736 6.17157L7.58579 9L4.75736 11.8284L6.17157 13.2426L9 10.4142L11.8284 13.2426L13.2426 11.8284L10.4142 9Z","fill":"black"}));
}

RejectedReminder.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = RejectedReminder;

RejectedReminder.default = RejectedReminder;
